import { IcoDownloadCloudArrowSmall } from '@icons';
import { downloadEntityTemplate } from '@lib/api';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

interface DownloadTemplateButtonProps {
	template: { label: string; value: string };
}

const DownloadTemplateButton: React.FC<DownloadTemplateButtonProps> = ({ template }) => {
	const downloadExportMutation = useMutation({
		mutationFn: (templateType: string) => downloadEntityTemplate(templateType),
	});
	return (
		<Button
			disabled={downloadExportMutation.isPending}
			onClick={() => {
				const templateType = template.value !== 'payments' ? template.value : 'invoicepayments';
				downloadExportMutation.mutate(templateType);
			}}
			className="btn custom-primary-button"
			style={{
				height: '48px',
				width: '175px',
				display: 'flex',
				gap: '0.5rem',
				justifyContent: 'center',
				alignItems: 'center',
				fontWeight: 500,
			}}
		>
			{downloadExportMutation.isPending ? (
				<>
					<Spinner animation="border" size="sm" role="status" />
					scaricando...
				</>
			) : (
				<>
					<IcoDownloadCloudArrowSmall /> Scarica
				</>
			)}
		</Button>
	);
};

export default DownloadTemplateButton;
